import Sprite from "../object-graphics/Sprite";
import PixelNumber from "../object-graphics/PixelNumber";
import { TILES } from "../../helpers/tiles";
import { useRecoilState, useRecoilValue } from "recoil";
import { currentLevelSelector } from "../../atoms/currentLevelAtom";
import { isChangeLevelMenuOpenAtom } from "../../atoms/changeLevelMenuAtom";
import styles from "./ChangeLevelButton.module.css";
import sounds, { SFX } from "../../classes/Sounds";
import { useRef } from "react";

export default function ChangeLevelButton() {
  const buttonRef = useRef();
  const currentLevel = useRecoilValue(currentLevelSelector);
  const [isChangeLevelMenuOpen, setIsChangeLevelMenuOpen] = useRecoilState(
    isChangeLevelMenuOpenAtom
  );
  return (
    <div className={styles.changeLevelButton}>
      <button
        ref={buttonRef}
        onClick={() => {
          sounds.playSfx(SFX.CLICK);
          setIsChangeLevelMenuOpen(!isChangeLevelMenuOpen);

          buttonRef.current.blur();
        }}
      >
        <Sprite frameCoord={TILES.MAP_BUTTON} />
        <PixelNumber number={currentLevel} />
      </button>
    </div>
  );
}
